<template >
  <div>
    <meu-menu> </meu-menu>
    <b-container>
      <b-row class="container-row">
        <b-col cols="12">
          <candidato-login
            v-if="
              vagas_id > 0 && (this.token == null || this.token.length == 0)
            "
            class="d-flex justify-content-center"
          ></candidato-login>

          <div>
            <!-- Descrição da Vaga Versão Desktop -->
            <b-row class="d-none d-md-block" v-if="vagas_id == 0">
              <b-row class="d-flex justify-content-center">
                <b-col md="8">
                  <!-- //? Display Vagas -->
                  <div class="main-card-vaga mt-3">
                    <div>
                      <img
                        src="../images/job-search.png"
                        class="img-box-detalhe"
                      />
                      <p>
                        <span class="titulo-vaga"> {{ vaga.nome }}</span>
                      </p>
                    </div>
                    <div>
                      <b v-if="vaga.codigo"> Código da vaga:</b>
                      <span v-if="vaga.codigo"> {{ vaga.codigo }} &nbsp;</span>
                      <b v-if="vaga.salario_vaga">Salário:</b>
                      <span v-if="vaga.salario_vaga">
                        {{ vaga.salario_vaga }}
                      </span>
                    </div>
                    <div class="box-detalhe-vagas">
                      <img
                        src="../images/map.png"
                        class="img-box-detalhe-mini"
                      />
                      <b v-if="vaga.bairro">Local:</b>
                      <span v-if="vaga.bairro"> {{ vaga.bairro }} </span>
                      <b v-if="vaga.horario_vaga"> Horário:</b>
                      <span v-if="vaga.horario_vaga">
                        {{ vaga.horario_vaga }}
                      </span>
                    </div>
                    <div class="box-detalhe-vagas">
                      <img
                        src="../images/geek.png"
                        class="img-box-detalhe-mini"
                      />
                      <b v-if="vaga.obs_candidato">Benefícios:</b>
                      <span
                        v-if="vaga.obs_candidato"
                        v-html="vaga.obs_candidato"
                      >
                      </span>
                    </div>
                    <div class="box-detalhe-vagas">
                      <img
                        src="../images/chat.png"
                        class="img-box-detalhe-mini"
                      />
                      <b v-if="vaga.atribuicoes">Descrição:</b>
                      <span v-if="vaga.atribuicoes" v-html="vaga.atribuicoes">
                      </span>
                    </div>
                    <div class="box-button-vagas">
                      <b-button
                        variant="success mt-2"
                        @click="vagas_id = vaga.id"
                        block
                      >
                        <font-awesome-icon icon="share" />
                        Encaminhar meu currículo para essa vaga
                      </b-button>
                    </div>
                  </div>
                </b-col>
                <!--//? Lista Vagas Lado Direito -->
                <b-col md="4" v-if="this.lista_vagas.length > 0">
                  <div
                    class="card-main mb-3 mt-3"
                    v-for="rows in this.lista_vagas"
                    :key="rows.id"
                  >
                    <p>
                      <span class="titulo-vaga"> {{ rows.nome }} </span>
                    </p>
                    <b><font-awesome-icon icon="barcode" /> Cod:</b>
                    {{ rows.codigo }}
                    <b><font-awesome-icon icon="map-marker-alt" /> Local:</b>
                    {{ rows.bairro }}
                    <p v-if="rows.atribuicoes">
                      <b
                        ><font-awesome-icon icon="comment-dots" /> Descrição da
                        vaga:</b
                      >
                      <span
                        v-html="rows.atribuicoes"
                        style="
                          display: -webkit-box;
                          -webkit-line-clamp: 6;
                          -webkit-box-orient: vertical;
                          overflow: hidden;
                        "
                      ></span>
                    </p>
                    <b-button variant="success btn-sm" @click="mudar(rows)"
                      ><font-awesome-icon icon="info-circle" /> Quero saber
                      mais</b-button
                    >
                  </div>
                </b-col>
              </b-row>
            </b-row>

            <!-- Card Descrição da Vaga Celular -->
            <div class="d-md-none" v-if="vagas_id == 0">
              <b-row>
                <b-col cols="12">
                  <b-card>
                    <b-row>
                      <b-col>
                        <span v-if="vaga.codigo" class="codigo-vaga">
                          {{ vaga.codigo }}
                        </span>
                        <br />
                        <span class="titulo-vagas"> {{ vaga.nome }} </span>
                        <br />
                        <span v-if="vaga.salario_vaga">
                          <b-badge variant="info">
                            Salário: {{ vaga.salario_vaga }}
                          </b-badge>
                        </span>
                        &nbsp;
                        <span v-if="vaga.bairro">
                          <b-badge variant="primary">
                            {{ vaga.bairro }}</b-badge
                          ></span
                        >
                        <br />
                        <span
                          v-if="vaga.horario_vaga"
                          class="descricao-vaga mt-1"
                        >
                          Horário: {{ vaga.horario_vaga }}
                        </span>
                        <br />
                        <span
                          v-if="vaga.obs_candidato"
                          v-html="vaga.obs_candidato"
                          class="descricao-vaga"
                        >
                        </span>
                        <hr />
                        <span class="codigo-vaga">Descrição da Vaga</span>
                        <br />
                        <span
                          v-if="vaga.atribuicoes"
                          v-html="vaga.atribuicoes"
                          class="descricao-vaga"
                        >
                        </span>
                        <hr />
                        <b-button
                          variant="success"
                          @click="vagas_id = vaga.id"
                          size="sm"
                          block
                          class="mr-3"
                        >
                          Quero me candidatar para a vaga</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </div>

            <div class="d-md-none" v-if="vagas_id == 0">
              <b-row class="mt-2">
                <b-col cols="12">
                  <b-card>
                    <b-row>
                      <b-col>
                        <b-button
                          variant="outline-secondary"
                          v-b-modal.modal-vagas-relacionadas
                          size="sm"
                          block
                          class="mr-3"
                        >
                          Toque para Visualizar Vagas Relacionadas</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </div>

            <!-- Fim do Card Descrição da Vaga Celular -->

            <!-- Modal Vagas Relacionadas Celular -->
            <b-modal
              id="modal-vagas-relacionadas"
              title="Vagas Relacionadas"
              scrollable
              class="test-modal"
            >
              <p class="modal-text">
                <span style="margin-bottom: 10px"
                  >Toque no nome da vaga para selecionar.</span
                ><br /><br />
                <b-row>
                  <b-col
                    sm="12"
                    v-for="rows in this.lista_vagas"
                    :key="rows.id"
                  >
                    <div class="vagas-relacionadas" @click="mudar(rows)">
                      <span class="codigo-vaga">{{ rows.codigo }}</span>
                      <br />
                      <span class="titulo-vagas"> {{ rows.nome }} </span>
                      <br />
                      <span
                        class="descricao-vaga"
                        v-if="rows.atribuicoes == null"
                      ></span>
                      <span
                        class="descricao-vaga"
                        v-if="rows.atribuicoes != null"
                        :inner-html.prop="rows.atribuicoes | truncate(250)"
                      >
                      </span>
                    </div>
                  </b-col>
                </b-row>
              </p>
            </b-modal>
            <!-- Fim do Modal Vagas Relacionadas Celular -->
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-console */
import Curriculo_Login from "../curriculo/Curriculo_Login";
import { sharedService } from "../../services";
import Menu from "../shared/Menu";
import Vaga from "../../model/Vaga";

export default {
  data() {
    return {
      vaga: new Vaga(),
      vagas_id: 0,
    };
  },
  components: {
    "meu-menu": Menu,
    "candidato-login": Curriculo_Login,
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    token: function () {
      return this.$store.getters.getToken;
    },
    lista_vagas: function () {
      return this.$store.getters.getListaVagas;
    },
  },
  created() {
    let self = this;

    if (this.$route.query.api_key && !this.$store.getters.getApiKey) {
      this.$store.dispatch("definirApiKey", this.$route.query.api_key);
    }

    if (this.$route.query.vaga_id) {
      this.pesquisa = this.$route.query.vaga_id;
      this.getData().then(() => {
        self.vaga = self.vagas[0];
        this.$store.dispatch("relacionadasVagasLoad", self.vaga.id);
      });
    } else {
      self.vaga = this.$route.params.vaga || null;
    }
  },
  methods: {
    detalhesVaga(item) {
      this.$router.push({
        name: "VagasAreasEdit",
        params: { nome: item },
      });
    },
    mudar(item) {
      history.pushState(
        {},
        null,
        `${this.$route.path}?api_key=${this.$store.getters.getApiKey}&vaga_id=${item.id}`
      );
      this.vaga = item;
      this.$store.dispatch("relacionadasVagasLoad", this.vaga.id);
    },
    encaminharVaga() {
      let self = this;

      console.log(self.token);

      if (self.vagas_id > 0 && self.token != null && self.token.length > 0) {
        this.$store.dispatch("pickVaga", this.vagas_id).then(function (obj) {
          obj.text().then(function (text) {
            if (obj.status === 200) {
              self.$swal({
                icon: "success",
                position: "top",
                title: "Curriculo Encaminhado",
                html: 'seu currículo será avaliado, caso aprovado voce será contactado, acompanhe o processo em <b>"Minhas vagas"</b>',
                footer: "em análise",
              });
            } else {
              self.$swal({
                icon: "error",
                position: "top",
                title: "Curriculo não Encaminhado",
                text: text,
                footer: "erro ao encaminhar o curriculo",
              });
            }
          });
        });

        this.vagas_id = 0;
      }
    },
    getData: async function (pageNum) {
      let self = this;

      if (pageNum === undefined) {
        pageNum = 1;
      }

      if (this.pesquisa !== "") {
        await sharedService
          .read(
            "VagasAbertas/" +
              this.$store.getters.getApiKey +
              "?limit=" +
              self.perPage +
              "&page=" +
              pageNum +
              "&search=" +
              this.pesquisa
          )
          .then(function (obj) {
            self.vagas = obj.obj;
            self.currentPage = obj.page;
            self.total = parseInt(obj.total_records, 0);
          });
      } else {
        await sharedService
          .read(
            "VagasAbertas/" +
              this.$store.getters.getApiKey +
              "?limit=" +
              self.perPage +
              "&page=" +
              pageNum
          )
          .then(function (obj) {
            self.vagas = obj.obj;
            self.currentPage = obj.page;
            self.total = parseInt(obj.total_records, 0);
          });
      }
    },
  },
  beforeMount() {
    this.$store.dispatch("relacionadasVagasLoad", this.vaga.id);
  },
  watch: {
    vagas_id: function () {
      this.encaminharVaga();
    },
    token: function () {
      this.encaminharVaga();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-success {
  background-color: #4cba9b;
  border-color: #4cba9b;
}

.btn-success:hover {
  background-color: #54ceac;
  border-color: #54ceac;
}

.bg-detalhe-vaga {
  background: #fff;
}

.img-box-detalhe {
  float: left;
  width: 80px;
  margin-right: 20px;
}

.img-box-detalhe-mini {
  width: 24px;
  margin-right: 8px;
}

.box-detalhe-vagas {
  background: #fff;
  border-radius: 8px;
  -webkit-box-shadow: 0 2px 8px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 2px 8px 0 rgb(0 0 0 / 10%);
  padding: 10px;
  border: 1px solid #dedede;
  margin: 10px;
}
.card-novas-vagas {
  background: #fff;
  border-bottom: 5px solid #73b0f4;
  border-radius: 10px;
  color: #424852;
  padding: 15px;
  -webkit-box-shadow: 0 4px 16px rgb(0 0 0 / 12%);
  box-shadow: 0 4px 16px rgb(0 0 0 / 12%);
}

.ultimas-vagas {
  background: #fff;
  padding: 10px;
  margin-bottom: 30px;
  border-radius: 5px;
  color: #447bfe;
}
.titulo-vaga {
  font-size: 1.5rem;
  font-weight: bold;
}

.titulo-vagas {
  color: #000;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 14px;
  line-height: inherit;
  font-weight: bold;
  white-space: nowrap;
  color: #e9ecef;
}

.card-vagas {
  background: var(--ion-item-background, var(--ion-background-color, #fff));
  color: #666;
  margin-top: 24px;
  margin-bottom: 24px;
  border-radius: 8px;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-transition: -webkit-transform 0.5s cubic-bezier(0.12, 0.72, 0.29, 1);
  transition: -webkit-transform 0.5s cubic-bezier(0.12, 0.72, 0.29, 1);
  transition: transform 0.5s cubic-bezier(0.12, 0.72, 0.29, 1);
  transition: transform 0.5s cubic-bezier(0.12, 0.72, 0.29, 1),
    -webkit-transform 0.5s cubic-bezier(0.12, 0.72, 0.29, 1);
  font-size: 14px;
  -webkit-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #dadada;
}

.codigo-vaga {
  color: #666;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.descricao-vaga {
  font-size: 13px;
  color: #5e5e5e;
  text-transform: lowercase;
}

.vagas-relacionadas {
  border-top: 1px solid #e4e4e4;
  padding-bottom: 10px;
  padding-top: 10px;
  padding-left: 5px;
}

.toolbar-title {
  display: block;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  pointer-events: auto;
  font-weight: 700;
}

.nav-superior-mobile {
  background: rgb(255, 255, 255) none repeat scroll 0% 0%;
  text-align: center;
  border-bottom: 1px solid #d9d9d9;
  padding: 18px;
}

.breadcrumb {
  border-radius: 8px;
}
.card-main {
  border-radius: 15px;
  margin-top: 4ch;
  min-height: 10vh !important;
}

.main-card-vaga {
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #e3e3e3;
  border-radius: 20px;
  padding: 1.25rem 1.25rem;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
}

.box-button-vagas {
  margin: 18px 10px 5px 10px;
}

.container {
  max-width: 90vw;
}

.container-row {
  margin: 0 auto;
  width: 100%;
}
</style>
